import { render, staticRenderFns } from "./CommonFormWithTempDeliveryEditor.vue?vue&type=template&id=67072896&lang=pug&"
import script from "./CommonFormWithTempDeliveryEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithTempDeliveryEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithTempDeliveryEditor.vue?vue&type=style&index=0&id=67072896&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports